import React, { useEffect, useState } from "react";
import {
  deleteServices,
  editServices,
  getServices,
} from "../../services/Admin/adminServices";
import Dropdown from "react-bootstrap/Dropdown";
import { Button, Modal, Form } from "react-bootstrap";
import toast from "react-hot-toast";
import { Formik, Field, Form as FormikForm, ErrorMessage } from "formik";
import * as Yup from "yup";
import EditServiceModal from "./ServicePosting";
import { useNavigate } from "react-router-dom";
import Pagination from "../components/Pagination";
import Spinner from "../components/Common/Spinner";
import { debounce } from "lodash";
const Notification = () => {
  const [service, setService] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [selectedService, setSelectedService] = useState(null);
  const [currentPage, setCurrentPage] = useState(0);
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const [loading, setLoading] = useState(false);
  const [totalItems, setTotalItems] = useState(0);
  const [search, setSearch] = useState("");
  const [debouncedSearch, setDebouncedSearch] = useState("");

  // Delete Confirmation Modal State
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [itemToDelete, setItemToDelete] = useState(null);
  const [deleting, setDeleting] = useState(false);

  const navigate = useNavigate()
  const getservices = async () => {
    try {
      setLoading(true);
      const response = await getServices(10, currentPage, debouncedSearch);
      setService(response?.data?.data?.services);
      setTotalItems(response?.data?.data.count);
    } catch (error) {
      console.error("errors", error);
    }
    finally {
      setLoading(false);
    }
  };

  const handleView = (serviceItem) => {
    setSelectedService(serviceItem);
    setShowModal(true);
  };
  const handleClose = () => {
    setShowModal(false);
    setSelectedService(null);
  };

  const handleDeleteClick = (serviceItem) => {
    setItemToDelete(serviceItem);
    setShowDeleteModal(true);
  };

  const handleConfirmDelete = async () => {
    if (!itemToDelete) return;
    try {
      setDeleting(true);
      await deleteServices(itemToDelete._id);
      setService((prev) => prev.filter((s) => s._id !== itemToDelete._id));
      setTotalItems((prev) => prev - 1);
      toast.success("Service deleted successfully");
      setShowDeleteModal(false);
      setItemToDelete(null);
    } catch (error) {
      console.error("error-> ", error);
      toast.error("Failed to delete service");
    } finally {
      setDeleting(false);
    }
  };

  const cleanObject = (obj, parentKey = "") => {
    if (Array.isArray(obj)) {
      return obj.map((item) => cleanObject(item, parentKey));
    } else if (obj && typeof obj === "object") {
      const newObj = {};
      for (const key in obj) {
        if (
          ["_id", "createdAt", "updatedAt"].includes(key)
          // ❌ remove "location" only if it's inside accessSupport

        ) {
          continue;
        }
        newObj[key] = cleanObject(obj[key], key);
      }
      return newObj;
    }
    return obj;
  };


  const handleUpdate = async (updatedValues, setSubmitting) => {


    const cleanAccessSupport = updatedValues.accessSupport.map((support) => {
      const cleaned = { ...support };

      // If support.location contains a nested location with coordinates, drop it
      if (
        cleaned.location &&
        cleaned.location.location &&
        cleaned.location.location.coordinates &&
        cleaned.location.location.coordinates.length === 0
      ) {
        delete cleaned.location.location; // remove bad nested location
      }

      return cleanObject(cleaned, "accessSupport");
    });
    const cleanFaq = (updatedValues.faq || []).map(({ _id, ...rest }) => rest);
    const cleanDescription = Array.isArray(updatedValues.description)
      ? updatedValues.description.map(({ _id, ...rest }) => rest)
      : updatedValues.description;

    const payload = {
      serviceId: updatedValues._id,
      title: updatedValues.title,
      email: updatedValues.email,
      description: cleanDescription,
      shortDescription: updatedValues.shortDescription,
      banner: updatedValues.banner,
      countryCodes: updatedValues.countryCodes,
      logo: updatedValues.logo,
      phoneNumber: updatedValues.phoneNumber,
      address: cleanObject(updatedValues.address),
      accessSupport: cleanAccessSupport,
      faq: cleanFaq
    };

    try {
      await editServices(payload);
      toast.success("Service updated successfully ");
      getservices();
      handleClose();
    } catch (error) {
      console.error("error->", error);
    }
    finally {
      setSubmitting(false);
    }
  };

  useEffect(() => {
    getservices();
  }, [currentPage, debouncedSearch]);


  useEffect(() => {
    const handler = debounce(() => {
      setDebouncedSearch(search);
    }, 500);

    handler();

    return () => {
      handler.cancel();
    };
  }, [search]);
  const svg1 = (
    <svg width="20px" height="20px" viewBox="0 0 24 24" version="1.1">
      <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <rect x="0" y="0" width="24" height="24"></rect>
        <circle fill="#000000" cx="12" cy="5" r="2"></circle>
        <circle fill="#000000" cx="12" cy="12" r="2"></circle>
        <circle fill="#000000" cx="12" cy="19" r="2"></circle>
      </g>
    </svg>
  );
  const totalPages = Math.ceil(totalItems / itemsPerPage);

  //  const validationSchema = Yup.object({
  //   title: Yup.string().required("Title is required"),
  //   phoneNumber: Yup.string()
  //     .matches(/^[0-9]+$/, "Must be only digits")
  //     .min(10, "Must be at least 10 digits")
  //     .required("Phone number is required"),
  //   email: Yup.string().email("Invalid email").required("Email is required"),
  // });

  // const handleUpdate = (values) => {
  //   // 👉 API call for update should go here
  //   // await updateService(values)
  //   setService((prev) =>
  //     prev.map((s) => (s._id === values._id ? { ...s, ...values } : s))
  //   );
  //   toast.success("Service updated successfully");
  //   handleClose();
  // };

  return (
    <div  >
      <h1 style={{ color: "#0AB7EA" }}>Services</h1>

      <div className="d-flex gap-2 align-items-center mb-3">

        <div className="flex-grow-1 ">
          <input
            type="text"
            style={{ borderRadius: "0.5rem", borderColor: "#0AB7EA" }}
            className="form-control w-100"
            placeholder="Search....."
            value={search}
            onChange={(e) => setSearch(e.target.value)}
          />
        </div>
        <div>
          <button

            className="btn"
            style={{
              backgroundColor: "#0AB7EA",
              color: "white",       // text color
              border: "none",       // remove border
              padding: "8px 16px",  // optional padding
              borderRadius: "4px",
              marginBottom: "4px" // optional rounded corners
            }}
            onClick={() => navigate("/add-services")}
          >
            Add new
          </button></div>
      </div>


      {loading ? (

        <Spinner />
      ) : service.length === 0 ? (
        <p>No service available.</p>
      ) : (<div className="row">
        {service.map((serviceItem, index) => (
          <div className="col-md-6 mb-4" key={serviceItem._id || index}>
            <div
              className={`card shadow-lg card-custom card-custom-${index % 6
                } position-relative`}
            >

              <div className="card-body d-flex justify-content-between align-items-start">
                <div>

                  {serviceItem.logo && (
                    <img
                      src={`https://api.socialjusticejamaica.com${serviceItem.logo}`}
                      alt="service logo"
                      style={{
                        width: "60px",
                        height: "60px",
                        borderRadius: "8px",
                        objectFit: "cover",
                        marginBottom: "10px",
                        border: "1px solid #ddd",
                        background: "#fff",
                        padding: "3px"
                      }}
                    />
                  )}
                  <h5 className="card-title">{serviceItem.title}</h5>
                  <p className="card-text mb-1">
                    <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M15.75 12.315V14.9671C15.75 15.3608 15.4456 15.6875 15.0529 15.7153C14.7248 15.7384 14.4572 15.75 14.25 15.75C7.62255 15.75 2.25 10.3774 2.25 3.75C2.25 3.54278 2.26159 3.27515 2.28476 2.94713C2.31253 2.55441 2.6392 2.25 3.03289 2.25H5.68508C5.87758 2.25 6.03882 2.39582 6.05815 2.58735C6.0755 2.7593 6.09163 2.89735 6.10655 3.00151C6.25826 4.06104 6.56815 5.06952 7.01152 6.00227C7.08269 6.15199 7.03628 6.33119 6.90139 6.42754L5.28266 7.58385C6.26814 9.88583 8.11417 11.7319 10.4162 12.7174L11.5703 11.1014C11.6679 10.9649 11.8492 10.918 12.0007 10.9899C12.9334 11.4329 13.9418 11.7425 15.0012 11.8938C15.1047 11.9087 15.2419 11.9246 15.4126 11.9419C15.6042 11.9612 15.75 12.1225 15.75 12.315Z" fill="#111111" />
                    </svg> {serviceItem.countryCodes} {serviceItem.phoneNumber}
                  </p>
                  <p className="card-text"> <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M2.25 2.25H15.75C16.1642 2.25 16.5 2.58579 16.5 3V15C16.5 15.4142 16.1642 15.75 15.75 15.75H2.25C1.83579 15.75 1.5 15.4142 1.5 15V3C1.5 2.58579 1.83579 2.25 2.25 2.25ZM9.04545 8.76218L4.23541 4.67828L3.26458 5.82172L9.05482 10.7378L14.7408 5.81712L13.7592 4.68288L9.04545 8.76218Z" fill="#111111" />
                  </svg> {serviceItem.email}</p>
                </div>
                <Dropdown>
                  <Dropdown.Toggle
                    variant="light"
                    id={`dropdown-basic-${index}`}
                    style={{ padding: "4px 8px" }}
                  >
                    {svg1}
                  </Dropdown.Toggle>

                  <Dropdown.Menu>
                    <Dropdown.Item onClick={() => handleView(serviceItem)}>
                      Edit
                    </Dropdown.Item>
                    <Dropdown.Item
                      onClick={() => handleDeleteClick(serviceItem)}
                    >
                      Delete
                    </Dropdown.Item>
                  </Dropdown.Menu>
                </Dropdown>
              </div>
            </div>
          </div>
        ))}
      </div>)}





      {selectedService && (
        <EditServiceModal
          show={setShowModal}
          handleClose={handleClose}
          initialData={selectedService}
          onSubmit={handleUpdate}
        />
      )}

      {/* Delete Confirmation Modal */}
      <Modal show={showDeleteModal} onHide={() => setShowDeleteModal(false)} centered size="md">
        <Modal.Header closeButton className="border-0 pb-0">
          <Modal.Title className="text-danger fw-bold fs-5">
            <i className="fa fa-exclamation-triangle me-2"></i> Confirm Delete Service
          </Modal.Title>
        </Modal.Header>
        <Modal.Body className="py-3">
          <p className="mb-0 text-secondary">
            Are you sure you want to delete <strong>"{itemToDelete?.title || "this service"}"</strong>? This action cannot be undone.
          </p>
        </Modal.Body>
        <Modal.Footer className="border-0 pt-0">
          <Button variant="secondary" onClick={() => setShowDeleteModal(false)} disabled={deleting}>
            Cancel
          </Button>
          <Button variant="danger" onClick={handleConfirmDelete} disabled={deleting}>
            {deleting ? (
              <>
                <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                Deleting...
              </>
            ) : (
              "Delete"
            )}
          </Button>
        </Modal.Footer>
      </Modal>


      <div className="card-footer clearfix">
        <div className="d-flex justify-content-between align-items-center">
          <div
            className="dataTables_info"
            style={{ color: "#0AB7EA" }}
          >
            Showing {currentPage * itemsPerPage + 1} to{" "}
            {totalItems > (currentPage + 1) * itemsPerPage
              ? (currentPage + 1) * itemsPerPage
              : totalItems}{" "}
            of {totalItems} entries
          </div>
          <div
            className="d-flex align-items-center"
            style={{ gap: "10px" }}
          >
            <Pagination
              pageCount={totalPages}
              pageValue={currentPage}
              setPage={setCurrentPage}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Notification;
